module.exports = __webpack_public_path__ + "img/honestidad.28ad4ea3.svg";